import { StrictDateRange } from '../../../../features/commonUI/DateRangeFilterSelect/types';
import { Stage } from '../../../entities/impl/blfApi/schemas/stage';
import { useGetStageReportQuery } from '../../impl/wrangler/endpoints/blueberry';
import { StageReportRequest } from '../../impl/wrangler/schemas/stageReportRequest';
import { StageReportResponseItem } from '../../impl/wrangler/schemas/stageReportResponse';

type UseBlueberryStageReportReturn = {
  data: StageReportResponseItem[] | undefined;
  isLoading: boolean;
};

export const useBlueberryStageReport = (
  customerId: string | undefined,
  stages: Stage[],
  dateRange?: StrictDateRange,
  skip = false
): UseBlueberryStageReportReturn => {
  const stageDefs = stages.map((stage) => ({
    stage_id: stage.id,
    stage_name: stage.name,
    filters: {
      class_names: [stage.className],
      color_sets: stage.colorSets || [],
      sub_classes: stage.subClasses || [],
    },
  }));

  const requestBody: StageReportRequest = {
    meta: {},
    data: {
      customer_id: customerId || '',
      start_date: dateRange?.start?.toISOString(),
      end_date: dateRange?.end?.toISOString(),
      stage_definitions: stageDefs,
    },
  };

  const { data, isLoading, isFetching } = useGetStageReportQuery(requestBody, {
    skip:
      !customerId ||
      !dateRange?.start ||
      !dateRange?.end ||
      !stages.length ||
      skip,
  });

  return {
    data,
    isLoading: isLoading || isFetching,
  };
};
